import { configureStore } from '@reduxjs/toolkit';
import storage from "redux-persist/lib/storage";
import { 
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
 } from 'redux-persist';
import { combineReducers } from '@reduxjs/toolkit';
import counterReducer from '../features/counter/counterSlice';
import authReducer from '../features/auth/authSlice';
import messagesReducer from 'features/message/messagesSlice';
import menuReducer from 'features/menu/menuSlice';

const persistConfig = {
  key: "root",
  version: 1,
  storage
};

const reducer = combineReducers({
  counter: counterReducer,
  auth: authReducer,
  messages: messagesReducer,
  menu: menuReducer
});

const persistedReducer = persistReducer(persistConfig, reducer); 

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});
